import { Dropdown, MenuItem, mergeClassnames } from '@heathmont/moon-core-tw';
import Lazy from '~/client/shared/LazyLoad/Lazy/Lazy';
import Disabled from './Disabled';
import InfoButton from './InfoButton';
import SelectionIcon from './SelectionIcon';
import useGameCurrencySelect from './useGameCurrencySelect';

const GameCurrencySelect = () => {
  const { isDisabled, options, isDesktop, selectedCurrency, handleChange } =
    useGameCurrencySelect();
  return (
    <Lazy>
      <div
        className={mergeClassnames(
          'relative grid grid-flow-col grid-cols-[11fr_1fr] gap-4',
          isDesktop && 'grid-cols-[2fr_1fr]',
        )}
      >
        <div>
          <div className="w-full md:w-32">
            <Dropdown
              value={selectedCurrency}
              onChange={handleChange}
              disabled={isDisabled}
              size="md"
            >
              <Dropdown.Select
                className="bg-gohan shadow-none md:bg-goku"
                data-testid="in-game-currency-select"
              >
                {isDisabled && <Disabled />}
                <span className="flex items-center gap-2">
                  <SelectionIcon currency={selectedCurrency} />
                  <span className="grow text-moon-14 text-trunks">
                    {selectedCurrency ?? '—'}
                  </span>
                </span>
              </Dropdown.Select>
              <Dropdown.Options menuWidth="w-28">
                {options.map(({ name, value, selected }) => (
                  <Dropdown.Option value={value} key={name}>
                    {({ active }) => (
                      <MenuItem isActive={active} isSelected={selected}>
                        <MenuItem.Title>{name}</MenuItem.Title>
                      </MenuItem>
                    )}
                  </Dropdown.Option>
                ))}
              </Dropdown.Options>
            </Dropdown>
          </div>
        </div>
        <InfoButton />
      </div>
    </Lazy>
  );
};

export default GameCurrencySelect;
